// extracted by mini-css-extract-plugin
module.exports = {"nodeWrapper":"xCUk9ZXQ"};